/**
 * @generated SignedSource<<e56d1fda2611ecafda31296e8e5e508a>>
 * @relayHash 826c65d984f5e45446a463bd2703b125
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b90114e45400c27329c9f3671de1e3eb4bc4b8f5c2c2062475b2629f69b5de5d

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceCreatePagePropertyInput = {
  key: string;
  pageId: string;
  value: string;
};
export type useEmojiEverSetPropertyMutation$variables = {
  input: ConfluenceCreatePagePropertyInput;
};
export type useEmojiEverSetPropertyMutation$data = {
  readonly confluence: {
    readonly createPageProperty: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useEmojiEverSetPropertyMutation = {
  response: useEmojiEverSetPropertyMutation$data;
  variables: useEmojiEverSetPropertyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "ConfluenceMutationApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "ConfluenceCreatePagePropertyPayload",
        "kind": "LinkedField",
        "name": "createPageProperty",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useEmojiEverSetPropertyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useEmojiEverSetPropertyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "826c65d984f5e45446a463bd2703b125",
    "id": "b90114e45400c27329c9f3671de1e3eb4bc4b8f5c2c2062475b2629f69b5de5d",
    "metadata": {},
    "name": "useEmojiEverSetPropertyMutation",
    "operationKind": "mutation",
    "text": "mutation useEmojiEverSetPropertyMutation($input:ConfluenceCreatePagePropertyInput!){confluence{createPageProperty(input:$input){success,errors{message}}}}"
  }
};
})();

(node as any).hash = "42e6e837e6f576cd47fb5d6479262cd6";

export default node;
